import { Form } from 'react-bootstrap';

const RepeatTypeSelector = ({ repeatType, setRepeatType }) => {
  const handleRepeatChange = (e) => {
    setRepeatType(e.target.value);
  };

  return (
    <div className="d-flex justify-content-between align-items-center mb-2">
      <Form.Label htmlFor="repeat-select" className="fw-bold text-white mb-1 mb-0">
        Repeat
      </Form.Label>
      <Form.Select
        id="repeat-select"
        value={repeatType}
        onChange={handleRepeatChange}
        className="bg-dark text-white border-secondary w-auto"
        style={{ minWidth: 180 }}
      >
        <option value="never">Never</option>
        <option value="daily">Every day</option>
        <option value="weekday">Every weekday</option>
        <option value="weekly">Every week</option>
        <option value="biweekly">Every 2 weeks</option>
        <option value="monthly">Every month</option>
        <option value="yearly">Every year</option>
        <option value="custom">Custom...</option>
      </Form.Select>
    </div>
  );
};

export default RepeatTypeSelector;
